module.exports = __webpack_public_path__ + "img/vegetable-rhubarb-190x100.084b7ebc.jpg";